import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './AppRoutingComponent';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class AppComponent extends Component {
    render() {
        return (
            <Router>
                <AppRouter />
                <ToastContainer />
            </Router>
        )
    }
}

export default AppComponent;
